import { FieldErrors } from "react-hook-form"
import Alert from "~/components/ui/Alert"
import Button from "~/components/ui/Button"
import Spinner from "~/components/ui/Spinner"
import { beautifyFieldName } from "~/utils/beautifyFieldName"

type Props = {
  isDirty: boolean
  isLoading?: boolean
  errors: FieldErrors<Record<any, any>>
  handleCancel?: () => void
  handleSubmit?: () => void
}

export default function SaveButtons({ isDirty, isLoading, handleCancel, handleSubmit, errors }: Props) {
  const errorMessages = Object.entries(errors)
    .map(([fieldName, error]) => {
      if (error && error.message) {
        return {
          field: beautifyFieldName(fieldName),
          message: typeof error.message === "string" ? error.message : String(error.message),
        }
      }
      return null
    })
    .filter(Boolean)

  return (
    <div className="flex flex-col gap-2">
      <div className="flex w-full items-center">
        {isDirty && <p className="text-gray-400">There are some changes that should be saved</p>}
        <Button disabled={!isDirty || isLoading} className="mr-4 ml-auto" onClick={handleCancel}>
          Cancel
        </Button>
        <div className="relative">
          <Button disabled={!isDirty || isLoading} variant="green" type="submit" onClick={handleSubmit}>
            Save
          </Button>
          {isLoading && (
            <div className="absolute top-0 left-1/2 transform -translate-x-1/3 flex items-center justify-center w-full h-full">
              <Spinner size={4} />
            </div>
          )}
        </div>
      </div>
      {!!errorMessages?.length && (
        <Alert
          description={
            <div className="flex flex-wrap gap-0.5">
              {errorMessages.map((error, index) => (
                <>
                  {index !== 0 && <>,&nbsp;</>}
                  <div key={index}>
                    <strong>{error.field}:</strong> {error.message}
                  </div>
                </>
              ))}
            </div>
          }
        />
      )}
    </div>
  )
}
